import React from "react";
import "./dashboard-sales-charges.css";

/**
 * Figma: Sales, Discounts, & Charges — three stat cards under weekly chart.
 * Sales strip: Other (remaining depts) | Wet | Tobacco | Combo from GetTodaySale.
 */
const PLACEHOLDER = {
  sales: [
    { key: "other", label: "Food Sales", value: 0 },
    { key: "wet", label: "Wet Sales", value: 0 },
    { key: "tobacco", label: "Tobacco Sales", value: 0 },
    { key: "combo", label: "Combo Sales", value: 0 },
  ],
  adjustments: [
    { key: "discounts", label: "Discounts", value: 0 },
    { key: "vouchers", label: "Vouchers", value: 0 },
  ],
  charges: [
    { key: "delivery", label: "Delivery Charges", value: 0 },
    { key: "service", label: "Service Charges", value: 0 },
    { key: "tips", label: "Tips", value: 0 },
    { key: "extras", label: "Extras", value: 0 },
  ],
};

function formatMoney(value, symbol = "£") {
  const n = Number(value) || 0;
  return `${symbol}${n.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

function StatGroup({ items, currencySymbol }) {
  const colsClass =
    items.length <= 2
      ? "dashboard-sdc__group--cols-2"
      : "dashboard-sdc__group--cols-4";

  return (
    <div className={`dashboard-sdc__group ${colsClass}`}>
      {items.map((item, index) => (
        <div
          key={item.key}
          className={`dashboard-sdc__stat${
            index < items.length - 1 ? " dashboard-sdc__stat--with-divider" : ""
          }`}
        >
          <div className="dashboard-sdc__value">
            {formatMoney(item.value, currencySymbol)}
          </div>
          <div className="dashboard-sdc__label">{item.label}</div>
        </div>
      ))}
    </div>
  );
}

function DashboardSalesCharges({
  sales = PLACEHOLDER.sales,
  adjustments = PLACEHOLDER.adjustments,
  charges = PLACEHOLDER.charges,
  currencySymbol = "£",
}) {
  return (
    <section
      className="dashboard-sdc"
      aria-label="Sales, discounts, and charges"
    >
      <h2 className="dashboard-sdc__heading">Sales, Discounts, &amp; Charges</h2>

      <div className="dashboard-sdc__grid">
        <article className="dashboard-sdc__card dashboard-sdc__card--sales">
          <StatGroup items={sales} currencySymbol={currencySymbol} />
        </article>

        <article className="dashboard-sdc__card dashboard-sdc__card--adjustments">
          <StatGroup items={adjustments} currencySymbol={currencySymbol} />
        </article>

        <article className="dashboard-sdc__card dashboard-sdc__card--charges">
          <StatGroup items={charges} currencySymbol={currencySymbol} />
        </article>
      </div>
    </section>
  );
}

export default DashboardSalesCharges;
